/** What GET /subscription/over-limit returns. */
export interface OverLimitStatus {
  over: boolean
  users: { current: number; max: number; over: boolean }
  products: { current: number; max: number; over: boolean }
  graceEndsAt: string | null
  readOnly: boolean
}

/** The warning for a store over its plan limits, or null when there is nothing to say. */
export function overLimitMessage(status: OverLimitStatus | null | undefined, now: Date = new Date()): string | null {
  if (!status?.over) return null

  const passed = [
    status.products.over ? `${status.products.current.toLocaleString()} of ${status.products.max.toLocaleString()} products` : null,
    status.users.over ? `${status.users.current} of ${status.users.max} users` : null,
  ].filter(Boolean).join(' and ')

  if (status.readOnly) {
    return `Your account is read-only because it's over your plan's limits (${passed}). You can still record in-store sales and trades. Remove items or upgrade to restore everything else.`
  }
  if (!status.graceEndsAt) return `Your account is over your plan's limits (${passed}). Remove items or upgrade.`

  const days = Math.max(1, Math.ceil((new Date(status.graceEndsAt).getTime() - now.getTime()) / (24 * 60 * 60 * 1000)))
  return `Your account is over your plan's limits (${passed}). Remove items or upgrade within ${days} ${days === 1 ? 'day' : 'days'}, or it becomes read-only. In-store sales and trades will keep working.`
}
